export const OTEL_SERVICE_NAME = 'frontend-dashboard-v2'
export const OTEL_SERVICE_VERSION = window.__APP_VERSION__ || 'dev'
export const OTEL_DEPLOYMENT_ENVIRONMENT = import.meta.env.DEV
  ? 'development'
  : 'production'

export const OTEL_URL = 'https://tempo.creatorhero.dev:8443/v1/traces'
